require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2022-01-12-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year-january-5th-2022.json") })
        }
      }, "path---news-2022-01-12-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year-january-5th-2022");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2022-01-12-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year-january-5th-2022!./.cache/json/news-2022-01-12-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year-january-5th-2022.json
// module id = 473
// module chunks = 231608221292675